// Extract a display host ("example.com") from a URL for link-preview labels.
export function linkHost(url) {
    if (!url) return '';
    try {
        return new URL(url).hostname.replace(/^www\./i, '');
    } catch {
        return '';
    }
}
